<template>
  <div class="modal-dialog-news">
    <ModalDialog ref="dialog" @hide="onHide">
      <div class="row news-full" id="news-full" v-if="data">
        <div class="art col-12 col-md-12">
          <img
            v-if="data.img.src"
            :src="data.img.src"
            :alt="data.img.alt"
            style="width:100%;max-width:100%;max-height:312px;object-fit:cover;"
          />
        </div>
        <h1 v-html="data.title" class="component-title col-10 col-md-12"></h1>
        <div v-html="data.date" class="date col-2 col-md-12"></div>
        <div
          class="desc columns-2 columns-1-md col-12"
          v-html="data.desc"
        ></div>
      </div>
      <div class="row" v-if="data">
        <ShareWidget
          class="col-12 col-12-md"
          theme="share"
          :printId="'news-full'"
          >Поделиться</ShareWidget
        >
      </div>
    </ModalDialog>
  </div>
</template>

<script>
import ModalDialog from "../components/ModalDialog.vue";
import ShareWidget from "../components/ShareWidget.vue";

import utils from "../utils";
import firestoreUtils from "../firestore-utils";
export default {
  name: "ModalDialogNews",
  data() {
    return {
      data: undefined,
      utils: utils,
    };
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    onHide() {
      setTimeout(() => {
        console.log(window.location.href);
        if (this.$route.path.indexOf("news") !== -1) {
          console.log("here");
          this.$router.push("/news");
        }
      }, 400);
    },
    fetchData() {
      this.data = undefined;
      this.doc = undefined;

      let id = parseInt(this.$route.params.id);
      if (id) {
        firestoreUtils
          .fetchWithFilter("newslist", {
            field: "id",
            condition: "==",
            value: id,
          })
          .then(result => {
            this.data = result.data[0];
            this.data.date = utils.parseDate(this.data.date);
          })
          .catch(() => {
            this.data = undefined;
          });
      }
    },
  },
  watch: {
    $route() {
      console.log();
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },
  components: {
    ModalDialog,
    ShareWidget,
  },
};
</script>

<style lang="scss">
.modal-dialog-news {
  h1 {
    margin-top: 0;
    margin-bottom: 00px;
  }
  .desc {
    p:first-child {
      margin-top: 0;
    }
    p:last-child {
      margin-bottom: 0;
    }
  }
  .date {
    @media all and (max-width: $md) {
      justify-self: flex-start;
      margin-top: 0px;
    }
    @extend %text-mini;
    justify-self: flex-end;
    text-align: right;
    margin-top: 6px;
  }
  .news-full {
    @media all and (max-width: $md) {
      grid-row-gap: 16px;
    }
    grid-row-gap: 36px;
    margin-bottom: 36px;
  }
  .art {
    @media all and (max-width: $md) {
      margin-bottom: 0;
    }
    margin-bottom: 10px;
  }
}
</style>
